import { motion } from "framer-motion";

/**
 * AnimatedBackground - rebalanced colorful blurred blobs + grid + noise.
 * Palette: cyan / teal / sky / coral / amber / pink (no purple dominance).
 */
export const AnimatedBackground = () => {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
      <div className="absolute inset-0 bg-[#060818]" />
      <div className="absolute inset-0 bg-aurora opacity-95" />

      <motion.div
        aria-hidden
        className="absolute -top-32 -left-24 h-[520px] w-[520px] rounded-full bg-cyan-400/30 blur-[120px] animate-blob-1"
      />
      <motion.div
        aria-hidden
        className="absolute top-24 -right-24 h-[460px] w-[460px] rounded-full bg-teal-400/25 blur-[110px] animate-blob-2"
      />
      <motion.div
        aria-hidden
        className="absolute top-[55%] left-[35%] h-[480px] w-[480px] rounded-full bg-rose-400/20 blur-[120px] animate-blob-3"
      />
      <motion.div
        aria-hidden
        className="absolute -bottom-24 right-1/4 h-[420px] w-[420px] rounded-full bg-amber-400/20 blur-[110px] animate-blob-1"
      />
      <motion.div
        aria-hidden
        className="absolute top-[120%] left-1/2 h-[420px] w-[420px] rounded-full bg-sky-400/20 blur-[120px] animate-blob-2"
      />
      <motion.div
        aria-hidden
        className="absolute top-[200%] left-[10%] h-[380px] w-[380px] rounded-full bg-pink-400/18 blur-[110px] animate-blob-3"
      />

      <div className="absolute inset-0 grid-soft opacity-60" />
      <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-[#060818]/80 to-transparent" />
      <div className="absolute inset-0 noise" />
    </div>
  );
};
